import { ILandingPageDataState } from 'models/landingpagedata';
import { Dispatch } from 'react-redux';
import { IStore } from 'redux/IStore';

/** Action Types */
export const REQUEST_START: string = 'landingpagedata/REQUEST_START';
export const REQUEST_FAILURE: string = 'landingpagedata/REQUEST_FAILURE';
export const RESET_DATA: string = 'landingpagedata/RESET_DATA';
export const SET_SALONS: string = 'landingpagedata/SET_SALONS';
export const SET_STATISTICS: string = 'landingpagedata/SET_STATISTICS';
export const SET_HOMEPAGE_STATISTICS: string = 'landingpagedata/SET_HOMEPAGE_STATISTICS';

interface ILandingPageDataAction {
	type: string;
	payload?: {
		message?: any;
		lastApprovedShops?: ILandingPageDataState['lastApprovedShops'];
		totalAppointments?: ILandingPageDataState['totalAppointments'];
		totalApprovedShops?: ILandingPageDataState['totalApprovedShops'];
		totalApprovedArticles?: ILandingPageDataState['totalApprovedArticles'];
	};
}

/** Initial State */
const getinitialState = (): ILandingPageDataState => ({
	lastApprovedShops: null,
	totalAppointments: null,
	totalApprovedShops: null,
	totalApprovedArticles: null,
});

/** Reducer */
export function landingPageDataReducer(
	state = getinitialState(),
	action: ILandingPageDataAction,
): ILandingPageDataState {
	switch (action.type) {
		case REQUEST_START:
			return {
				...state,
				isFetching: true,
				error: false,
				message: undefined,
			};

		case SET_HOMEPAGE_STATISTICS:
			return {
				...state,
				isFetching: false,
				error: false,
				message: undefined,
				lastApprovedShops: action.payload.lastApprovedShops,
				totalAppointments: action.payload.totalAppointments,
				totalApprovedArticles: action.payload.totalApprovedArticles,
				totalApprovedShops: action.payload.totalApprovedShops,
			};

		case REQUEST_FAILURE:
			return {
				...state,
				isFetching: false,
				error: true,
				message: action.payload.message,
			};

		case RESET_DATA:
			return getinitialState();

		default:
			return state;
	}
}

export function requestStart(): ILandingPageDataAction {
	return {
		type: REQUEST_START,
	};
}

export function resetData(): ILandingPageDataAction {
	return {
		type: RESET_DATA,
	};
}

export function setHomePageStatistics(homepageStatistics): ILandingPageDataAction {
	return {
		type: SET_HOMEPAGE_STATISTICS,
		payload: {
			lastApprovedShops: homepageStatistics.lastApprovedShops.items,
			totalAppointments: homepageStatistics.totalAppointments,
			totalApprovedArticles: homepageStatistics.totalApprovedArticles,
			totalApprovedShops: homepageStatistics.totalApprovedShops,
		},
	};
}

export function requestFailure(message: any): ILandingPageDataAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

export function getHomePageStatistics() {
	return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
		dispatch(requestStart());

		const queryString = '?currentPage=1&itemsPerPage=4';

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/HomePageStatistics' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((json) => {
						dispatch(setHomePageStatistics(json));
						return { error: false };
					});
				} else {
					dispatch(requestFailure(res.statusText));
					return { error: true };
				}
			})
			.catch((e) => {
				console.error(e);
				return { error: true };
			});
	};
}
